import { Button, Skeleton, DatePicker, Card, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  generatedISOFormatDateString,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import * as echarts from 'echarts';
import * as XLSX from "xlsx";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";



const ElectricalHistoricalTrends = () => {
  const chartRef = useRef(null);  
  const {loading,  makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]); 
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(); 
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter,setParameter]=useState([]);
  const [data1,setData1]= useState([]);
  const [data2,setData2]= useState([]);
  const [data3,setData3]= useState([]);
  const [parameterLenght, setParameterLenght] = useState('')
  const defaultParameters = ['kWhImport','KWT','IAVG','VLLAvg'];
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
      });

    makeRequest({  
       type: APIConstants.POST,
       url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });
      makeRequest({  
        type: APIConstants.GET, 
        url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setParameter(res);
      });
   
  },[])

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.POST,  
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId])
 
  
  function transformDatas(inputData) {
    // Initialize arrays to store unique CreatedOn values and unique meter names
    const createdOn = [];
    const meterNames = [];
    
    // Collect unique CreatedOn values and meter names
    inputData.forEach(entry => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      if (!createdOn.includes(formattedDate)) {
        createdOn.push(formattedDate);
      }
      if (!meterNames.includes(entry.METERNAME)) {
        meterNames.push(entry.METERNAME);
      }
    });
  
    // Initialize series array with meter names
    const series = meterNames.map(meterName => ({
      name: meterName,
      type: 'line',
      stack: 'Total',
      data: Array(createdOn.length).fill(0) // Initialize with zeros for each CreatedOn value
    }));
  
    inputData.forEach(entry => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      const dateIndex = createdOn.indexOf(formattedDate);
      const meterIndex = meterNames.indexOf(entry.METERNAME);
  
      if (dateIndex !== -1 && meterIndex !== -1) {
        series[meterIndex].data[dateIndex] += entry.KWHTotal;
      }
    });
  
    // Return the formatted structure
    return { series, createdOn, meterNames };
  }
  

function prepareLineChartData(data, excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]) {
  const series = [];
  const xAxisData = [];
  const metrics = {};
  const parameters=[];
  
  function removeDuplicates(inputArray) {
    console.log(inputArray)
    const seen = new Set();
    const result = [];
    
    inputArray.forEach(item => {
      if (!seen.has(item)) {
        result.push(item); 
        seen.add(item);
      }
    });
     
    return result;
  }

  data.forEach((entry) => {
      // Add unique timestamps to x-axis  
      if (!xAxisData.includes(entry.CreatedOn.replace("T", " "))) {
          xAxisData.push(entry.CreatedOn.replace("T", " ")); 
      }

      // Iterate through all fields in the entry
      for (const key in entry) {
          if (!excludeFields.includes(key)) {
              // Group by METERNAME and metric (e.g., KWHTotal)
              const metricKey = `${entry.METERNAME}-${key}`;
              if (!metrics[metricKey]) {
                  metrics[metricKey] = [];
              }
              metrics[metricKey].push(entry[key]);
              parameters.push(key);

          }
      }
  });

  // Prepare series for ECharts
  for (const [metricName, values] of Object.entries(metrics)) {
      series.push({
          name: metricName,
          type: 'line',
          data: values, 
      });
  }
  const para = removeDuplicates(parameters);
  console.log(para);
  console.log(xAxisData);
  const uniqueTimestamps = Array.from(
    new Set(xAxisData.map(ts => {
      const [date, time] = ts.split(' '); // Split date and time
      const timeWithoutSeconds = time.split(':').slice(0, 2).join(':'); // Keep hour and minute
      return `${date} ${timeWithoutSeconds}:00`; // Append :00 for seconds
    }))
  );

  console.log(uniqueTimestamps)
  // Return the chart configuration

  return {
      xAxisData:uniqueTimestamps,
      series: series,
      parameter:para
  };
}

  
  const getResponse =(inputData)=>{
    console.log(inputData);
    setIsLoading(true);
    
    makeRequest({ 
        type: APIConstants.GET,  
        url: `${APIConstants.ELECTRICAL_HISTORICAL_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}` 
      }).then((res) => {
        console.log(res)
        setsteamHistoricalData(res);
        if (res&&res.length>0) {    
          const data = transformDatas(res);
          console.log(data)
          console.log(data.meterNames)
          // setData1(data.createdOn) 
          // setData2(data.series)
          // setData3(data.meterNames)
          const test =prepareLineChartData(res)
          console.log(test)
          setData1(test.xAxisData)
          setData2(test.series)
          // setData3(test.parameter)
        }
        setIsLoading(false);
      });
  }
 
  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values.length>4) {
      console.log(values);
      setParameterLenght('Cannot select more than 4 values');
    }else{
      setParameterLenght('');
    }
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");
    const para = selectedValues?.map((id) => id).join(",");
    console.log(para)

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      Parameters:para||0,
      MeterIds: ids || [1],
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    console.log(inputData)
    getResponse(inputData);
  };

  useEffect(() => {
    setChartInputData();
  },[]);
 
  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  },[steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError 
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(true); 
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  const updateChart = async () => { 
    try {
      setChartLoading(true);
  
      // Filter steamHistoricalData based on selected meter IDs
      const selectedMeterData = steamHistoricalData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterId)
      );
  
      // Transform the data in a chart series format
      const transformData = (parameterName, meterName) => {
        const data = selectedMeterData
          ?.filter((item) => item?.sitename === meterName)
          ?.map((item) => item[parameterName]);
        return {
          name: `${parameterName}-${meterName}`,
          data,
        };
      };
  
      const seriesData = [];
      console.log(selectedValues)
      console.log(nsGetFlowConverterList)
  
      // Iterate over selected meter IDs and selectedValues properties
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          console.log(meterName)
  
        selectedValues.forEach(({ parametername }) => {
          seriesData.push(transformData(parametername, meterName));
        });
      });

      console.log(selectedValues)
      console.log(seriesData)
  
      const datesArray = [];
      const dateProperty = "createdOn";
      
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          
        datesArray.push(transformData(dateProperty, meterName));
      });
  
      // Filter to include only selected parameter names in selectedValues
      const finalData = seriesData.filter((series) => 
        selectedValues.some(({ parametername }) => series.name.includes(parametername))
      );
  
      // Find the longest date array and reverse it
      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);
  
      const reversedFinalData = finalData.map((data) => ({
        data: data.data.reverse(),
        name: data.name,
      }));
  
      // Format dates for x-axis
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      console.log(reversedFinalData)
  
      // setData1(reversedFinalData);
      // setData2(localDateTime);
  
      setChartLoading(false);
    } catch (err) {
      console.error(err);
      setChartLoading(false);
    }
  };

  const exportToExcel = (data) => {
    // Transform the data into a tabular format
    const headers = ["S. No.", ...data.map((item) => item.name)];
    const rows = Array.from({ length: data[0].data.length }, (_, i) => [
      ` ${i + 1}`,
      ...data.map((item) => item.data[i]),
    ]);
  
    const excelData = [headers, ...rows];
  
    // Create a new workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  
    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");
  
    // Generate a filename with the current date and time in local timezone
    const now = new Date();
    const timestamp = now
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false, // Use 24-hour format
      })
      .replace(/[/,: ]/g, "-"); // Replace unwanted characters for a filename
  
    const filename = `Historical_Trends_${timestamp}.xlsx`;
  
    console.log("Generated Filename: ", filename);
  
    
    XLSX.writeFile(workbook, filename);
  };
  
     useEffect(() => {
        if (selectedValues.length === 0) {
          setSelectedValues(defaultParameters); 
        }
      }, [selectedValues]);
  
  useEffect(() => {
    if (loading || !data1 || !data2) return; // Prevent chart rendering if loading or data is unavailable
  
    console.log(data1);
    console.log(data2);
  
    const myChart = echarts.init(chartRef.current);
  
    const option = { 
      backgroundColor: isdarkMode ? '#2d3748' : '#fff',
      title: {
        text: `Historical Trends`,
        left: 'center',
        top: '5px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black',
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        confine: true, 
        position: function (point, params, dom, rect, size) {
          // `point` is the mouse position, `[x, y]`
          // `size` contains the size of the tooltip
          const [x, y] = point;
          const { contentSize, viewSize } = size; // Size of the tooltip and view
      
          let xPos = x + 10; // Add some padding
          let yPos = y + 10;
      
          // Prevent overflow on the right
          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20; // Move it left
          }
      
          // Prevent overflow on the bottom
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 1000; // Move it up
          }
      
          return [xPos, yPos];
        },
      },
      
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '25%', 
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        feature: {
          myExport: {
            show: true,
            title: "Export to Excel",
            icon: "path://M5 0L15 10L5 20Z", 
            onclick: () => {
              exportToExcel(data2);
            },
          },
          mark: { show: true },
          magicType: { show: true, type: ['line', 'bar'] },
          saveAsImage: { show: true },
        },
        iconStyle: {
          borderColor: isdarkMode ? 'white' : 'black',
        },
        emphasis: {
          iconStyle: {
            borderColor: isdarkMode ? '#FFD700' : '#1E90FF', 
          },
        },
      },
      xAxis: [
        {
          type: 'category',
          data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`), // Example categories
          axisTick: { show: false },
          data: data1,
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      series: data2,
      dataZoom: [
        {
          type: 'inside', // Enables zooming via scroll or pinch
          start: 0,
          end: 100,
        },
      ],
    };
    
  
    myChart.setOption(option);
  
    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);
  
    return () => {
      window.removeEventListener('resize', resizeHandler);
      myChart.dispose();
    };
  }, [data1, data2, isdarkMode, loading]); // Include loading in dependencies
  

  return (
    <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
      {/* {isLoading  &&(
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div> 
      )} */}
     
      <Card 
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative' }}
      >  
{
          !data1.length >0 && !loading &&
          <div className="text-3xl">
          <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          </div> 
         } 
          {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
        <div ref={chartRef} className={`${(!loading||!loadings) && data1.length>0 ? 'min-h-[80vh]':'h-0'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>

        </Card>


        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="id"        
            nameKey="name"     
            valueKey="name" 
            // <SteamTreeSelectCustom
            // label="Parameters:"
            // data={parameter}
            // idKey="parameterid"
            // nameKey="parametername"
            // valueKey="parameterid"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button> 
        </div>
      </CustomDrawer>
    </div>
  );
};

export default ElectricalHistoricalTrends;
